import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FlowStateExplanation = ({ state, activities }) => {
  const explanations = {
    FLOW: "L'exercice de cette compétence-clé est susceptible de vous permettre de ressentir du Flow si vous avez l'occasion de relever des challenges.",
    MAITRISE: "Pour cette activité:\n- vous disposez d'un niveau de compétence élevé ;\n- vous avez un niveau d'intérêt modéré.",
    ENNUI: "Pour cette activité:\n- vous disposez d'un niveau de compétence élevé ;\n- vous avez un niveau d'intérêt faible.",
    EXCITATION: "Pour ces activités:\n- vous disposez d'un niveau de compétence moyen ;\n- vous avez un niveau d'intérêt élevé.",
    NEUTRE: "Pour ces activités:\n- vous disposez d'un niveau de compétence moyen ;\n- vous avez un niveau d'intérêt modéré.",
    DETACHEMENT: "Pour ces activités:\n- vous disposez d'un niveau de compétence moyen ;\n- vous avez un niveau d'intérêt faible.",
    INQUIETUDE: "Pour cette activité:\n- vous disposez d'un niveau de compétence faible ;\n- vous avez un niveau d'intérêt modéré.",
    INDIFFERENCE: "Pour ces activités:\n- vous disposez d'un niveau de compétence faible ;\n- vous avez un niveau d'intérêt faible.",
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
        {explanations[state]}
      </Typography>
      <List>
        {activities.map((activity, index) => (
          <ListItem key={index}>
            <ListItemText primary={activity} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

const CompetencySection = ({ title, data }) => {
  const groupedByFlowState = data.reduce((acc, item) => {
    if (!acc[item.flowState]) {
      acc[item.flowState] = [];
    }
    acc[item.flowState].push(item.activity);
    return acc;
  }, {});

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {Object.entries(groupedByFlowState).map(([state, activities]) => (
          <Box key={state} sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
              {activities.length > 1 
                ? `Vos compétences non techniques en ${state}`
                : `Votre compétence non technique en ${state}`}
            </Typography>
            <FlowStateExplanation state={state} activities={activities} />
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

const DetailedCompetencyAnalysis = ({ synthesisData }) => {
  return (
    <Paper sx={{ p: 3, mt: 3 }}>
      <Typography variant="h5" gutterBottom>
        Évaluation de vos compétences non techniques
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 3 }}>
        Nous avons classé vos compétences en trois catégories selon leur niveau relatif et l'état psychologique que vous êtes le plus susceptible de ressentir en les exerçant. Les compétences en gras sont celles qui peuvent le mieux contribuer à votre réussite professionnelle.
      </Typography>

      <CompetencySection 
        title="Compétences élevées" 
        data={synthesisData.élevées || []} 
      />
      
      <CompetencySection 
        title="Compétences moyennes" 
        data={synthesisData.moyennes || []} 
      />
      
      <CompetencySection 
        title="Compétences faibles" 
        data={synthesisData.faibles || []} 
      />
    </Paper>
  );
};

export default DetailedCompetencyAnalysis;
